import pkdApi from 'store/api/pkd';
import { TaskTitles } from 'utils/enum';

const graphsApi = pkdApi.injectEndpoints({
  endpoints : (build) => ({
    getAgeGraph : build.query({
      query : () => ({
        url    : '/age_category',
        method : 'GET',
      }),
    }),
    getHeatMapGraph : build.query({
      query : () => ({
        url    : '/heatmap',
        method : 'GET',
      }),
    }),
    getEGFRGraph : build.query({
      query : ({ personId }) => ({
        url    : `/getEGFR/${personId}`,
        method : 'GET',
      }),
      providesTags : [
        { type: 'ParticipantTasks', id: TaskTitles.coreQuestionnaire },
      ],
    }),
    getQualityOfLifeScoreGraph : build.query({
      query : ({ personId }) => ({
        url    : `/getQualityOfLifeScore/${personId}`,
        method : 'GET',
      }),
      providesTags : [{ type: 'ParticipantTasks', id: TaskTitles.ADPKDIS }],
    }),
    getRegistryCount : build.query({
      query : ({ personId }) => ({
        url    : `/registryCount/${personId}`,
        method : 'GET',
      }),
    }),
    getFatigueAndAbdomenSizeScoreGraph : build.query({
      query : ({ personId }) => ({
        url    : `/fatigueAndAbdomenSizeScore/${personId}`,
        method : 'GET',
      }),
      providesTags : [{ type: 'ParticipantTasks', id: TaskTitles.ADPKDIS }],
    }),
    getFamilyHistoryScore : build.query({
      query : () => ({
        url    : '/family_history',
        method : 'GET',
      }),
      providesTags : [
        { type: 'ParticipantTasks', id: TaskTitles.familyHistory },
      ],
    }),
    getDistanceTraveledToSeeClinician : build.query({
      query : () => ({
        url    : '/distance_traveled',
        method : 'GET',
      }),
      providesTags : [
        { type: 'ParticipantTasks', id: TaskTitles.healthCareAccess },
      ],
    }),
    getStudyParticipation : build.query({
      query : () => ({
        url    : '/study_participation',
        method : 'GET',
      }),
      providesTags : [
        { type: 'ParticipantTasks', id: TaskTitles.coreQuestionnaire },
      ],
    }),
    getAneurysmsScreening : build.query({
      query : () => ({
        url    : '/aneurysms_screening',
        method : 'GET',
      }),
      providesTags : [
        { type: 'ParticipantTasks', id: TaskTitles.vascularOutcomesGeneral },
      ],
    }),
    getLiverScore : build.query({
      query : () => ({
        url    : '/liverLargerThanAverage',
        method : 'GET',
      }),
      providesTags : [{ type: 'ParticipantTasks', id: TaskTitles.liverCyst }],
    }),
    getEHRBloodPressure : build.query({
      query : ({ personId }) => ({
        url    : `/getEHRData/bloodPressure/${personId}`,
        method : 'GET',
      }),
    }),
    getEHRCareTeam : build.query({
      query : ({ personId }) => ({
        url    : `/getEHRData/careteam/${personId}`,
        method : 'GET',
      }),
    }),
    getEHREGFR : build.query({
      query : ({ personId }) => ({
        url    : `/getEmrEGFRData/${personId}`,
        method : 'GET',
      }),
    }),
  }),
  overrideExisting : false,
});

export const {
  useGetAgeGraphQuery,
  useGetRegistryCountQuery,
  useGetHeatMapGraphQuery,
  useGetEGFRGraphQuery,
  useGetQualityOfLifeScoreGraphQuery,
  useGetFatigueAndAbdomenSizeScoreGraphQuery,
  useGetDistanceTraveledToSeeClinicianQuery,
  useGetFamilyHistoryScoreQuery,
  useGetStudyParticipationQuery,
  useGetAneurysmsScreeningQuery,
  useGetLiverScoreQuery,
  useGetEHRBloodPressureQuery,
  useGetEHRCareTeamQuery,
  useGetEHREGFRQuery,
} = graphsApi;
